import { PasswordRecoveryContent } from "@/features/password-recovery";
import { Layout } from "../Layout";

export const PasswordRecovery = () => {
  return (
    <Layout>
      <PasswordRecoveryContent />
    </Layout>
  );
};
